import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Multiselect from 'multiselect-react-dropdown';
import AxiosService from "../services/axios.service";
const API_PATH = "firms";

const GOOGLE_MAP_API_KEY = "AIzaSyA8oEXVIh8RoYuGQO-J0-iMEAL0wQGYSU8";

const loadGoogleMapScript = (callback) => {
    if (
        typeof window.google === "object" &&
        typeof window.google.maps === "object"
    ) {
        callback();
    } else {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
        window.document.body.appendChild(googleMapScript);
        googleMapScript.addEventListener("load", callback);
    }
};

function AddEditFirm({ history, match }) {
    const placeInputRef = useRef(null);
    const { id } = match.params;
    const isAddMode = !id;
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState([]);
    const [attorneys, setAttorneys] = useState([]);
    const [address, setAddress] = useState("");

    // form validation rules 
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Firm Name is required'),
        street: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        zip: Yup.string(),
        website: Yup.string()
    });

    function handleChange(event) {
        console.log("kekker " + event.target.value);
        setAddress(event.target.value);
    }

    function onSelect(selectedList, selectedItem) {
        setAttorneys(selectedList);
    }

    function onRemove(selectedList, removedItem) {
        setAttorneys(selectedList);
    }

    function selectAddress(place) {
        console.log(place.formatted_address);
        var address_fields = place.formatted_address.split(",");
        setValue("street", address_fields[0]);
        setValue("city", address_fields[1]);
        setValue("state", address_fields[2]);
        setValue("zip", address_fields[3]);
        setValue("latitude", place.geometry.location.lat());
        setValue("longitude", place.geometry.location.lng());
    }

    const initPlaceAPI = () => {
        let autocomplete = new window.google.maps.places.Autocomplete(
            placeInputRef.current
        );
        new window.google.maps.event.addListener(
            autocomplete,
            "place_changed",
            function () {
                selectAddress(autocomplete.getPlace());
            }
        );
    };

    // functions to build form returned by useForm() hook
    const { register, watch, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {
        var staff = [];
        for (var x in attorneys) {
            var attorney = new Object();
            attorney.id = attorneys[x].id;
            attorney.name = attorneys[x].name;
            staff.push(attorney);
        }

        data.attorneys = staff;
        return isAddMode
            ? createFirm(data)
            : updateFirm(id, data);
    }

    function createFirm(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                console.log(data);
                history.push('.');
            })
    }

    function updateFirm(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                history.push('..');
            })
    }

    useEffect(() => {
        register("address");
        register("street");
        register("city");
        register("state");
        register("zip");
        register("latitude");
        register("longitude");

        loadGoogleMapScript(() => {
            initPlaceAPI();
        });

        AxiosService.getAll("attorneys").then(x => setOptions(x.data));
        if (!isAddMode) {
            // get firm and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var firm = x.data;
                setAttorneys(firm.attorneys);
                const fields = ['name', 'street', 'city', 'state', 'zip', 'website'];
                //maybe handles attorneys as well!?
                setSelectedValue(firm.attorneys);
                fields.forEach(field => setValue(field, firm[field]));
                setAddress(firm.street + ", " + firm.city + ", " + firm.state);
            });
        }
    }, []);

    const onFocus = event => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }
    };

    return (
        <form onFocus={onFocus} onSubmit={handleSubmit(onSubmit)} onReset={reset}>
            <h1>{isAddMode ? 'Add Firm' : 'Edit Firm'}</h1>

            <div className="form-group col-5">
                <label>Firm Name</label>
                <input autoComplete="off" name="name" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                <div className="invalid-feedback">{errors.name?.message}</div>
            </div>

            <div className="form-group col-5">
                <label>Address</label>
                <input autoComplete="new-password" id="address" name="address" type="text" value={address} onChange={handleChange} ref={placeInputRef} className={`form-control ${errors.address ? 'is-invalid' : ''}`} />
                <div className="invalid-feedback">{errors.address?.message}</div>
            </div>

            <div className="form-group col-5">
                <label>Website</label>
                <input autoComplete="off" name="website" type="text" ref={register} className={`form-control ${errors.website ? 'is-invalid' : ''}`} />
                <div className="invalid-feedback">{errors.website?.message}</div>
            </div>

            <div className="form-group col-5">
                <label>Attorneys</label>
                <Multiselect
                    options={options} // Options to display in the dropdown
                    selectedValues={selectedValue} // Preselected value to persist in dropdown
                    onSelect={onSelect} // Function will trigger on select event
                    onRemove={onRemove} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                    closeOnSelect={true}
                    avoidHighlightFirstOption="true"
                />
            </div>

            <div className="form-group">
                <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                    {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Save
                </button>
                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
            </div>
        </form>
    );
}

export { AddEditFirm };